<template>
    <div>
        <div class="container" style="min-width: 900px">
            <el-form ref="priceForm" :model="price" :rules="priceRules" label-width="85px">
                <el-form-item label="用户ID" prop="userId">
                    <el-input v-model="price.userId" style="width: 270px; margin-right: 10px;"></el-input>
                    <!-- 弹框, 添加指定用户-->
                    <el-popover
                        placement="right-start"
                        width="400"
                        trigger="click"
                        >
                        <el-table 
                            :data="user.toBeTableData" 
                            height="537"
                            v-loading="user.loading"
                            stripe
                            >
                            <el-table-column width="233px" prop="userId" label="用户名">
                                <template slot="header" slot-scope="scope">
                                    <el-input
                                        :slot="scope"
                                        @keyup.enter.native="SpecifyUserChange"
                                        v-model.trim="userIdSearch"
                                        size="mini"
                                        placeholder="回车搜索"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column prop="nickName" label="昵称"></el-table-column>
                            <el-table-column width="68" label="">
                                <template style="cursor: pointer;" slot-scope="scope">
                                    <div style="cursor: pointer; width: 100%">
                                        <el-button @click="addUsers(scope.row)">添加</el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleUserPageChange"
                            :current-page="user.pageIndex"
                            :page-size="user.pageSize"
                            :total="user.pageTotal"
                            layout="prev, pager, next, jumper"
                            background
                            ></el-pagination>
                        </div>
                        <el-button slot="reference" icon="el-icon-plus" circle></el-button>
                    </el-popover>
                    
                </el-form-item>
                <el-form-item label="货币类型" prop="priceType">
                    <el-select v-model="price.priceType" placeholder="请选择" style="width: 100px">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数量" prop="number">
                    <el-input v-model="price.number" style="width: 270px"></el-input>
                </el-form-item>
            </el-form>
            <div style="margin-left: 85px">
                <el-button type="primary" :disabled="loading" @click="submitForm('priceForm')" :loading="loading">修 改</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { ext } from '../../../../utils/rsa.js'
import { getNormalUser, getPriceKeyByUserId, updateUserPrice } from '../../../api/gameconsole-mars.js'

export default {
    name: 'MarsAddPriceRecord',
    data: function(){
        const isNum = (rule, value, callback) => {
            const age= /^[0-9]*$/
            if (!age.test(value)) {
                callback(new Error('只能为数字'))
            }else{
                callback()
            }
        }
        return {
            // 表单数据
            price: {
                userId: '',
                priceType: '0',
                number: ''
            },

            userIdSearch: '',  //搜索
            user: {
                tableData: [],     //已添加用户
                toBeTableData: [], //可添加用户
                pageIndex: 1,
                pageSize: 10,
                pageTotal: 1,
                loading: false,

                username: ''
            },

            // 选择器
            options: [
                {
                    value: '0',
                    label: '免费'
                },
                {
                    value: '1',
                    label: '付费'
                }
            ],
            priceRules: {
                userId: [
                    { required: true, message: '用户ID不能为空' }
                ],
                number: [
                    { required: true, message: '货币数量不能为空' },
                    { validator: isNum, trigger: 'blur' }
                ],
            },
            loading: false
        }
    },
    created() {
        this.SpecifyUserChange()
    },
    activated() {
    },
    methods: {
        submitForm(priceForm) {
            // 表单验证
            this.$refs[priceForm].validate((valid) => {
                if (valid) {
                    this.loading = true
                    // 获取随机key
                    let keyParams = { 'userId': this.price.userId }
                    getPriceKeyByUserId(keyParams).then(res => {
                        if (res.data.message == '请求成功！') {

                            // 随机key
                            let key = res.data.data.sercetKey 
                            // 生成时间戳
                            let time = parseInt(new Date().getTime() / 1000)
                            // 未加密参数
                            let data = {'userId': this.price.userId, 'priceType': this.price.priceType, 
                                        'number': this.price.number, 'key': key, 'keyTime': time}
                            data = JSON.stringify(data)
                            
                            // 加密参数
                            let enData = ext.en(data)
                            // 加签 
                            let sign = ext.si(data)
                            let headers = {'sign': sign}
                            let params = {'data': enData}

                            //发送请求
                            updateUserPrice(params, headers).then(res => {
                                if (res.data.message == "请求成功！") {
                                    this.loading = false
                                    this.$message.success(res.data.message)
                                } else {
                                    this.loading = false
                                    this.$message.error(res.data.message)
                                }
                            })
                        } else {
                            this.loading = false
                            this.$message.error(res.data.message)
                        }
                    }).catch(err => {
                        this.loading = false
                    })
                }
            })
        },

        //指定用户 - 获取用户表格数据
        SpecifyUserChange() {
            this.user.loading = true
            let params = {'id': this.userIdSearch, 'pageIndex': this.user.pageIndex, 'pageSize': this.user.pageSize }
            getNormalUser(params).then(res => {
                if(res.data.code == 200) {
                    this.user.toBeTableData = res.data.data.records
                    this.user.pageTotal = res.data.data.total

                    //移除已被添加的用户数据
                    this.user.tableData.forEach(item => {
                        //移除已经添加过去的数据
                        this.user.toBeTableData = this.user.toBeTableData.filter(jtem => {
                            return item.userId !== jtem.userId
                        })
                    })
                }
                this.user.loading = false
            }).catch(err => {
                this.user.loading = false
            })
        },

        //从 可添加用户Table 添加到 已添加用户Table
        addUsers(user) {
            this.price.userId = user.userId
        },

        //上一页 下一页
        handleUserPageChange(pageIndex) {
            this.user.pageIndex = pageIndex
            this.SpecifyUserChange()
        },
        //手动输入页码
        handleSizeChange(pageIndex){
            this.user.pageIndex = pageIndex
            this.SpecifyUserChange()
        },
    }
}
</script>

<style scoped lang="scss">
    .handle-input {
        width: 260px;
        display: inline-block;
        margin-right: 10px;
    }
</style>
